// extracted by mini-css-extract-plugin
export var messageSideLeft = "_l3-1";
export var messageSideRight = "_l3-2";
export var subscribeToBackInStockBubbleContainer = "_l3-0";